import React from "react"
import styled from "styled-components"
import { IconChat } from "./Icons"

const ChatNotifyIcon = ({ count = 0, type }) => {
    const bg = type === "host" ? "#FF0102" : "#000000"

    return (
        <Wrapper>
            <Badge $bg={bg} $visible={count > 0}>
                {count}
            </Badge>
            <IconChat />
        </Wrapper>
    )
}

export default ChatNotifyIcon

/* ========== Styled Components ========== */

const Wrapper = styled.div`
  position: relative;
  width: max-content;
  margin: auto;
`

const Badge = styled.div`
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  background: ${(props) => props.$bg};
  top: -10px;
  left: -10px;
  font-size: 11px;
  color: #fff;
  display: ${(props) => (props.$visible ? "flex" : "none")};
  align-items: center;
  justify-content: center;
  text-align: center;
`